module.exports = __webpack_public_path__ + "img/Communities.bc3c7ce2.png";